module.exports = __webpack_public_path__ + "static/media/iPhoneX.8506bc64.png";